"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScreenSize = void 0;
var _react = require("react");
const useScreenSize = () => {
  const [width, setWidth] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    const updateWindowDimensions = () => {
      let newWidth = 0;
      if (typeof window !== "undefined") {
        newWidth = window.innerWidth;
        setWidth(newWidth);
        window.addEventListener("resize", updateWindowDimensions);
      }
      return () => {
        if (typeof window !== "undefined") {
          return window.removeEventListener("resize", updateWindowDimensions);
        }
      };
    };
    updateWindowDimensions();
  }, []);
  return {
    width
  };
};
exports.useScreenSize = useScreenSize;